import { render } from "./Spider.vue?vue&type=template&id=b5647abe&scoped=true"
import script from "./Spider.vue?vue&type=script&lang=js"
export * from "./Spider.vue?vue&type=script&lang=js"

import "./Spider.vue?vue&type=style&index=0&id=b5647abe&scoped=true&lang=css"

import exportComponent from "/var/lib/docker/jenkins_home/workspace/spider-web-gp-tools-s3-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5647abe"]])

export default __exports__